export function customSelect() {
  $(window).on("load", () => {
    jcf.setOptions("Select", {
      wrapNative: false,
      wrapNativeOnMobile: true,
      fakeDropInBody: false,
      maxVisibleItems: 4,
      useCustomScroll: true
    });

    jcf.replaceAll();

    setTimeout(function () {
      jcf.destroy($(".lang-switcher select"));
    }, 100);

    this.$document.on("click", function (event) {
      if($(event.target).closest(".jcf-select").length) {
        $(event.target).closest(".form-row").toggleClass("select-opened");
      } else {
        $(".form-row").removeClass("select-opened");
      }
    });
    
    this.$document.on("keypress", function (event) {
      let keyCode = event.which;
      if (keyCode === 13) {
        event.preventDefault();
        if($(event.target).siblings(".jcf-select").length) {
          $(event.target).closest(".form-row").toggleClass("select-opened");
        }
      }
    });
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js